import {useEffect, useState, useCallback, forwardRef, useImperativeHandle} from "react";
import {useDispatch, useSelector} from "react-redux";
import EditFieldGroup from "../../../components/EditFieldGroup";
import EditField from "../../../components/EditFieldGroup/EditField";
import Toaster from "../../../components/Toaster";
import DatePicker from "react-datepicker";
import * as opportunityActions from "../../../redux/Opportunity/actions.js";
import LoadingPanel from "../../../components/LoadingPanel";
import AccountSelect from "../../../components/AccountSelect";
import ContactSelect from "../../../components/ContactSelect";

import './EditOpportunity.scss';

const EditOpportunity = forwardRef((props, ref) => {
	const { onClose, editMode, forceReload, autofillMode, missedAccountDetails } = props;
	const [editOpportunity, setEditOpportunity] = useState({...props.opportunity});
	const [resetDropdowns, setResetDropdowns] = useState(1);
	const [selectedVendor, setSelectedVendor] = useState(editOpportunity?.Leading_Cloud__c ||'-1');
	const [selectedEndCustomer, setSelectedEndCustomer] = useState(null);
	const [selectedCloudPOC, setSelectedCloudPOC] = useState(null);
	const [nextStepPOC, setNextStepPOC] = useState(null);
	const [updatedFields, setUpdatedFields] = useState({});
	const user = useSelector(state => state.user.user);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	const picklists = useSelector(state => state.opportunity.picklists);

	useEffect(() => {
		const load = async () => {
			await dispatch(opportunityActions.loadOpportunityPicklists());
			setLoading(false);
		};
		load();
	}, []);


	useEffect(() => {
		const load = async () => {
			if(!editMode && picklists != null) {
				const acc = user.customers.find(c => c.Name === user.accountName);
				editOpportunity.Customer_Status__c = autofillMode ? editOpportunity.Customer_Status__c : picklists['Customer_Status__c'][0].value;
				let isOnACEPSC = 'Yes';
				if(autofillMode){
					const missedDetails = props.missedAccountDetails.find(a => a.accounts[0].id === editOpportunity.accountId);
					isOnACEPSC = !missedDetails?.accounts[0].engaged_greenfield ||  missedDetails?.accounts[0].engaged_greenfield.toLowerCase() === 'engaged' ? 'Yes' : 'No';
					setSelectedEndCustomer(editOpportunity.End_Customer_Name)
					setSelectedCloudPOC(editOpportunity.Cloud_POC__Name)
				}
				editOpportunity.Is_on_ACE_PSC__c = autofillMode ? isOnACEPSC : picklists['Is_on_ACE_PSC__c'][0].value;
				editOpportunity.Activity_Type__c = autofillMode ? editOpportunity.Activity_Type__c : picklists['Activity_Type__c'][0].value;
				editOpportunity.Leading_Cloud__c = autofillMode ? editOpportunity.Leading_Cloud__c :
				editOpportunity.StageName = autofillMode ? editOpportunity.StageName : picklists['StageName'][0].value;
				editOpportunity.Priority__c = autofillMode ? editOpportunity.Priority__c : picklists['Priority__c'][0].value;

				editOpportunity.AccountId = acc?.Id;
				editOpportunity.Name = ".";
				editOpportunity.CloseDate = new Date();
				editOpportunity.Next_Step_Date__c = new Date();
				editOpportunity.Account_Team_First_Call__c = new Date();
				editOpportunity.Customer_First_Meeting__c = new Date();
				editOpportunity.Contract_Effective_Date__c = new Date();
				editOpportunity.Renewal_date__c = new Date();
				editOpportunity.ISV_Opportunity_Stage__c = picklists['ISV_Opportunity_Stage__c'][0].value;
				editOpportunity.Opportunity_Heat__c = picklists['Opportunity_Heat__c'][0].value;
				editOpportunity.ACE_Partner_Center_Status__c = picklists['ACE_Partner_Center_Status__c'][0].value;
				editOpportunity.Is_for_Marketplace__c = picklists['Is_for_Marketplace__c'][0].value;
				editOpportunity.Propensity_to_Buy__c = picklists['Propensity_to_Buy__c'][0].value;
				editOpportunity.Payment_Terms__c = picklists['Payment_Terms__c'][0].value;
				editOpportunity.Lost_Reason__c = picklists['Lost_Reason__c'][0].value;
			}
			if(editMode) {
				const parseDate = (date) => (date ? new Date(date) : null);
				const createFieldObject=(field)=> field ? {label:field,value:'fakeId'} : null;

				editOpportunity.CloseDate = parseDate(editOpportunity.CloseDate);
				editOpportunity.Next_Step_Date__c = parseDate(editOpportunity.Next_Step_Date__c);
				editOpportunity.Account_Team_First_Call__c = parseDate(editOpportunity.Account_Team_First_Call__c);
				editOpportunity.Customer_First_Meeting__c = parseDate(editOpportunity.Customer_First_Meeting__c);
				editOpportunity.Contract_Effective_Date__c = parseDate(editOpportunity.Contract_Effective_Date__c);
				editOpportunity.Renewal_date__c = parseDate( editOpportunity.Renewal_date__c)
				editOpportunity.Last_Meeting_Date__c = parseDate(editOpportunity.Last_Meeting_Date__c) 

				setSelectedEndCustomer(createFieldObject(editOpportunity.End_Customer__r?.Name))
				setSelectedCloudPOC(createFieldObject(editOpportunity.Cloud_POC__r?.Name))
				setNextStepPOC(createFieldObject(editOpportunity.Next_Step_POC__r?.Name))	
			}
		};
		load();
	}, [picklists, missedAccountDetails]);

	const checkRequiredFields = () => {
		if(selectedVendor === '-1') {
			Toaster.showWarn('Leading Cloud is required');
			return true;
		}
		else if(!selectedEndCustomer) {
			Toaster.showWarn('End Customer is required');
			return true;
		}
		else if(!selectedCloudPOC) {
			Toaster.showWarn('Cloud POC is required');
			return true;
		}
		else if(!editOpportunity.NextStep || editOpportunity.NextStep === "") {
			Toaster.showWarn('Next Steps field is required');
			return true;
		}
	};

	const opportunityCreated = (result) => {
		setLoading(false);
		if(result?.status === "ok") {
			Toaster.showSuccess("Opportunity created successfully.")
			onClose();
			if(forceReload){
				forceReload()
			}
		}
		else {
			Toaster.showError(result?.error?.message||'Internal server error');
		}
	};

	const opportunityUpdated = (result) => {
		setLoading(false);
		if(result.status === "ok") {
			Toaster.showSuccess("Opportunity updated successfully.")
			onClose();
		}
		else {
			Toaster.showError(result.error.message);
		}
	};

	const createOpportunity = useCallback(() => {
		// validation
		if(checkRequiredFields()){
			return
		}

		setLoading(true);
		dispatch(opportunityActions.createOpportunity(editOpportunity, opportunityCreated));
	}, [editOpportunity, dispatch, selectedVendor, selectedEndCustomer, selectedCloudPOC]);

	const updateOpportunity = useCallback(() => {
		if(checkRequiredFields()){
			return
		}

		setLoading(true);
		dispatch(opportunityActions.saveOpportunity(editOpportunity.Id, updatedFields,selectedVendor, opportunityUpdated));
	}, [editOpportunity, updatedFields, selectedVendor, dispatch, selectedEndCustomer, selectedCloudPOC]);

	// Expose save method to parent via ref
	useImperativeHandle(ref, () => ({
		save: editMode ? updateOpportunity : createOpportunity
	}), [editMode, updateOpportunity, createOpportunity]);

	if(loading) {
		return (
			<div>
				<LoadingPanel hide />
			</div>
		)
	}

	const updateField = (field, value) => {
		let parsedValue = value;
    if (['Amount', 'Probability', 'Deal_Term_M__c'].includes(field)) {
        if (value === '') {
            parsedValue = null; // Allow null for empty inputs
        } else if (!isNaN(value)) {
            parsedValue = parseFloat(value); // Parse valid numbers
        } else {
            Toaster.showWarn(`${field} must be a number or left empty.`);
            return; // Prevent invalid values
        }
    }
		// update the edit object for visual
		const temp = {...editOpportunity};
		temp[field] = value;
		setEditOpportunity(temp);

		// For edit mode: update only changed fields object for the save action
		const temp1 = {...updatedFields};
		temp1[field] = value;
		setUpdatedFields(temp1);
	};


	const updateVendor = (e) => {
		const vendor = e.target.value;
		setSelectedVendor(vendor);
		const text = e.target.selectedOptions[0].text;
		updateField('Leading_Cloud__c', text);
		setResetDropdowns(resetDropdowns + 1);
		setSelectedEndCustomer(null);
		setSelectedCloudPOC(null);
		setNextStepPOC(null);
	};

	const onChangeEndCustomer = (option) => {
		setSelectedEndCustomer(option);
		updateField('End_Customer__c', option.value);
	};

	const onChangeCloudPOC = (option) => {
		setSelectedCloudPOC(option);
		updateField('Cloud_POC__c', option.value);
	}

	const onChangeNextStepPOC = (option) => {
		setNextStepPOC(option);
		updateField('Next_Step_POC__c', option.value);
	}

	return (
		<>
			<div className="edit-opportunity-container">
				<EditFieldGroup title="Details">
					{
						editMode &&
						<EditField title="Opportunity Owner">
							<div className="edit-field-styles-readonly">{editOpportunity.Owner_First_Name__c}</div>
						</EditField>
					}

					{
						editMode &&
						<EditField title="Opportunity Name">
							<div className="edit-field-styles-readonly">{editOpportunity.Name}</div>
						</EditField>
					}

					<EditField title="Account Name">{editMode ? editOpportunity.Account.Name : user.accountName}</EditField>

					<EditField required title="End Customer">
								<AccountSelect reset={resetDropdowns} value={selectedEndCustomer} onChange={onChangeEndCustomer} disabled={selectedVendor === '-1'} vendor={selectedVendor} />
					</EditField>

					<EditField required title="Opportunity Type">
						<select className="edit-field-styles select-primary" value={editOpportunity.Activity_Type__c || ''} onChange={(e) => updateField('Activity_Type__c', e.target.value)}>
							{ picklists['Activity_Type__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>

					<EditField required title="Cloud POC">
								<ContactSelect reset={resetDropdowns} value={selectedCloudPOC} onChange={onChangeCloudPOC} disabled={selectedVendor === '-1'} vendor={selectedVendor} />
					</EditField>

					<EditField required title="Leading Cloud">
								<select className="edit-field-styles select-primary" value={selectedVendor} onChange={updateVendor}>
									<option value="-1">Please Select</option>
									{
										picklists['Leading_Cloud__c']
											.filter(p => p.label === 'AWS' || p.label === 'Microsoft')
											.map((opt, i) => (
												<option key={i} value={opt.value === 'AWS & Microsoft' ? 'AWS;Microsoft' : opt.value}>{opt.label}</option>
											))
									}
								</select>
					</EditField>

					<EditField required title="Customer Status">
						<select className="edit-field-styles select-primary" value={editOpportunity.Customer_Status__c || ''} onChange={(e) => updateField('Customer_Status__c', e.target.value)}>
							{ picklists['Customer_Status__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>

					<EditField required title="Stage">
						<select className="edit-field-styles select-primary" value={editOpportunity.StageName || ''} onChange={(e) => updateField('StageName', e.target.value)}>
							{ picklists['StageName'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>
					<EditField title="Probability (%)">
						<input type="text" className="edit-field-styles" value={editOpportunity.Probability || ''} onChange={(e) => updateField('Probability', e.target.value)} />
					</EditField>

					<EditField required title="Priority">
						<select className="edit-field-styles select-primary" value={editOpportunity.Priority__c || ''} onChange={(e) => updateField('Priority__c', e.target.value)}>
							{ picklists['Priority__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>
					<EditField title="Opportunity Heat">
						<select className="edit-field-styles select-primary" value={editOpportunity.Opportunity_Heat__c || ''} onChange={(e) => updateField('Opportunity_Heat__c', e.target.value)}>
							{ picklists['Opportunity_Heat__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>

					<EditField title="ISV Opportunity Owner">
						<div className="edit-field-styles-readonly">{editOpportunity.ISV_Opportunity_Owner__c}</div>
					</EditField>
					<EditField title="ISV Opportunity Stage">
						<select className="edit-field-styles select-primary" value={editOpportunity.ISV_Opportunity_Stage__c || ''} onChange={(e) => updateField('ISV_Opportunity_Stage__c', e.target.value)}>
							{ picklists['ISV_Opportunity_Stage__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>
					<EditField title="Deal Acceleration Reason">
						<textarea
							className="edit-field-styles"
							value={editOpportunity.Deal_Acceleration_Reason__c || ''}
							onChange={(e) => updateField('Deal_Acceleration_Reason__c', e.target.value)}
							placeholder=""
							rows="3"
						></textarea>
					</EditField>
					<EditField required title="Close Date">
						<DatePicker
							className="date-field-styles"
							placeholderText="Pick Date"
							selected={editOpportunity.CloseDate}
							onChange={date => updateField('CloseDate', date)}
							popperClassName="datePickerCalendar"
							disabledKeyboardNavigation
							monthsShown={1}
							dateFormat="P"
						/>
					</EditField>
					<EditField title="Is for Marketplace?">
						<select className="edit-field-styles select-primary" value={editOpportunity.Is_for_Marketplace__c || ''} onChange={(e) => updateField('Is_for_Marketplace__c', e.target.value)}>
							{ picklists['Is_for_Marketplace__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>

					<EditField title="Propensity to Buy">
						<select className="edit-field-styles select-primary" value={editOpportunity.Propensity_to_Buy__c || ''} onChange={(e) => updateField('Propensity_to_Buy__c', e.target.value)}>
							{ picklists['Propensity_to_Buy__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>
					<EditField title="ACE/Partner Center Status">
						<select className="edit-field-styles select-primary" value={editOpportunity.ACE_Partner_Center_Status__c || ''} onChange={(e) => updateField('ACE_Partner_Center_Status__c', e.target.value)}>
							{ picklists['ACE_Partner_Center_Status__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>

					<EditField required title="Is on ACE/Partner Center?">
						<select className="edit-field-styles select-primary" value={editOpportunity.Is_on_ACE_PSC__c || ''} onChange={(e) => updateField('Is_on_ACE_PSC__c', e.target.value)}>
							{ picklists['Is_on_ACE_PSC__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>
					<EditField title="Use Case Details">
						<input type="text" className="edit-field-styles" value={editOpportunity.Use_Case_Details__c || ''} onChange={(e) => updateField('Use_Case_Details__c', e.target.value)} />
					</EditField>

					<EditField title="Unique Identifier">
						<input type="text" className="edit-field-styles" value={editOpportunity.Unique_Identifier__c || ''} onChange={(e) => updateField('Unique_Identifier__c', e.target.value)} />
					</EditField>
					<EditField title="Description">
						<input type="text" className="edit-field-styles" value={editOpportunity.Description || ''} onChange={(e) => updateField('Description', e.target.value)} />
					</EditField>
				</EditFieldGroup>

				<EditFieldGroup title="Activity">
					<EditField required title="Next Step">
						<input type="text" className="edit-field-styles" value={editOpportunity.NextStep || ''} onChange={(e) => updateField('NextStep', e.target.value)} />
					</EditField>

					<EditField required title="Next Step Date">
						<DatePicker
							className="date-field-styles"
							placeholderText="Pick Date"
							selected={editOpportunity.Next_Step_Date__c}
							onChange={date => updateField('Next_Step_Date__c', date)}
							popperClassName="datePickerCalendar"
							disabledKeyboardNavigation
							monthsShown={1}
							dateFormat="P"
						/>
					</EditField>

					<EditField title="Next Step POC">
						<ContactSelect
							reset={resetDropdowns}
							disabled={selectedVendor === '-1'}
							vendor={selectedVendor}
							value={nextStepPOC}
							onChange={onChangeNextStepPOC}
						/>
					</EditField>

					{/*<EditField title="Next Step Owner">*/}
						{/*{editOpportunity.Next_Step_Owner__r?.Name}*/}
					{/*</EditField>*/}

					<EditField title="Account Team First Call">
						<DatePicker
							className="date-field-styles"
							placeholderText="Pick Date"
							selected={(editOpportunity.Account_Team_First_Call__c)||null}
							onChange={date => updateField('Account_Team_First_Call__c', date)}
							popperClassName="datePickerCalendar"
							disabledKeyboardNavigation
							monthsShown={1}
							dateFormat="Pp"
							showTimeSelect
							timeIntervals='15'
						/>
					</EditField>

					<EditField title="Customer First Meeting">
						<DatePicker
							className="date-field-styles"
							placeholderText="Pick Date"
							selected={(editOpportunity.Customer_First_Meeting__c)||null}
							onChange={date => updateField('Customer_First_Meeting__c', date)}
							popperClassName="datePickerCalendar"
							disabledKeyboardNavigation
							monthsShown={1}
							dateFormat="Pp"
							showTimeSelect
							timeIntervals='15'
						/>
					</EditField>

					<EditField title="Last Meeting Date">
						<DatePicker
							className="date-field-styles"
							placeholderText="Pick Date"
							selected={editOpportunity.Last_Meeting_Date__c||null}
							onChange={date => updateField('Last_Meeting_Date__c', date)}
							popperClassName="datePickerCalendar"
							disabledKeyboardNavigation
							monthsShown={1}
							dateFormat="P"
						/>
					</EditField>

					<EditField title="On Hold?">
						<input type="checkbox" className="checkbox-primary" checked={editOpportunity.On_Hold__c} onChange={(e) => updateField('On_Hold__c', e.target.checked)} />
					</EditField>
					<EditField title="Campaign">
						{editOpportunity.Campaign__c}
					</EditField>
				</EditFieldGroup>

				<EditFieldGroup title="Commercials" expandable>
					<EditField title="Amount">
						<input type="text" className="edit-field-styles" value={editOpportunity.Amount || ''} onChange={(e) => updateField('Amount', e.target.value)} />
					</EditField>

					<EditField title="Contract Effective Date">
						<DatePicker
							className="date-field-styles"
							placeholderText="Pick Date"
							selected={editOpportunity.Contract_Effective_Date__c}
							onChange={date => updateField('Contract_Effective_Date__c', date)}
							popperClassName="datePickerCalendar"
							disabledKeyboardNavigation
							monthsShown={1}
							dateFormat="P"
						/>
					</EditField>

					<EditField title="Deal Term (M)">
						<input type="text" className="edit-field-styles" value={editOpportunity.Deal_Term_M__c || ''} onChange={(e) => updateField('Deal_Term_M__c', e.target.value)} />
					</EditField>
					{/*<EditField title="MRR">*/}
						{/*<input type="text" className="edit-field-styles" value={editOpportunity.MRR__c || ''} onChange={(e) => updateField('MRR__c', e.target.value)} />*/}
					{/*</EditField>*/}

					<EditField title="Payment Terms">
						<select className="edit-field-styles select-primary" value={editOpportunity.Payment_Terms__c || ''} onChange={(e) => updateField('Payment_Terms__c', e.target.value)}>
							{ picklists['Payment_Terms__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>

					<EditField title="Renewal date">
						<DatePicker
							className="date-field-styles"
							placeholderText="Pick Date"
							selected={editOpportunity.Renewal_date__c}
							onChange={date => updateField('Renewal_date__c', date)}
							popperClassName="datePickerCalendar"
							disabledKeyboardNavigation
							monthsShown={1}
							dateFormat="P"
						/>
					</EditField>
				</EditFieldGroup>

				<EditFieldGroup title="Lost Opportunities" expandable>
					<EditField title="Lost Reason">
						<select className="edit-field-styles select-primary" value={editOpportunity.Lost_Reason__c || ''} onChange={(e) => updateField('Lost_Reason__c', e.target.value)}>
							{ picklists['Lost_Reason__c'].map((opt, i) => (<option key={i} value={opt.value}>{opt.label}</option>)) }
						</select>
					</EditField>
				</EditFieldGroup>

			</div>
		</>
	)
});

export default EditOpportunity;
